<template>
    <div>
        <div class="mb-3 ">
            <h5 class="un run">Regulation Versions</h5>
            <b-button @click="handleModal()" variant="primary" type="button" size="sm" class="mt-1">
                <i class="mdi mdi-plus mr-1"> </i> Create
            </b-button>
        </div>

        <webix-ui :config="ui" v-model="regulation_versions"></webix-ui>
        <div id="legislationPaging"></div>
    </div>
</template>

<script>
import { certificateValidationComputed, certificateValidationMethods } from "../../../state/helpers";
//eslint-disable-next-line

export default {
    data: () => ({
        affidavit_data: [
            { id: "1", type: "Affidavits", start_date: "1 Jan 2022", end_date: "30 Aug 2022" },
            { id: "2", type: "Affidavits", start_date: "1 Sep 2022", end_date: "current" },
            { id: "3", type: "Certificates", start_date: "1 Jan 2022", end_date: "current" },
        ],
    }),
    computed: {
        ...certificateValidationComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "legislationTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                hover: "suppliersTableHoverRow",
                minHeight: 50,
                minColumnWidth: 120,
                rowHeight: 30,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                select: true,
                editable: true,
                pager: {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "legislationPaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                },
                columns: [
                    // TODO: Delete
                    // {
                    //     id: "type",
                    //     header: ["Type"],
                    //     tooltip: false,
                    // },
                    {
                        id: "name",
                        header: ["Name"],
                        tooltip: false,
                        width: 300,
                    },
                    {
                        id: "start_date",
                        header: ["Start Date"],
                        tooltip: false,
                        // fillspace: 1,
                        width: 150,
                        template: function(obj) {
                            return obj.start_date.substring(0, 10);
                        },
                    },
                    {
                        id: "end_date",
                        header: ["End Date"],
                        tooltip: false,
                        // fillspace: 1,
                        width: 150,
                        template: function(obj) {
                            if (obj.end_date !== null) {
                                return obj.end_date.substring(0, 10);
                            }

                            return "Current";
                        },
                    },
                ],
                ready() {
                    // const table = window.webix.$$("legislationTable");
                    // //eslint-disable-next-line
                    // const rowId = "1";
                    // if (table.exists()) {
                    //     table.select(1);
                    // }
                    // const table = window.webix.$$("legislationTable");
                    // let sel = table.getSelectedId();
                    //eslint-disable-next-line
                    // console.log("the watch", table.getSelectedId(), sel);
                    //eslint-disable-next-line
                    // table.select(1);
                },
                on: {
                    onBeforeSelect(id) {
                        //eslint-disable-next-line
                        let item = this.getItem(id);
                        //eslint-disable-next-line
                        let el = this.$scope.$parent;
                        //eslint-disable-next-line
                        console.log("I was clciked", item);

                        // el.hanldeEmit("value", item);
                        // el.$emit("selectedRegulationVersion", item);
                        // el.s;
                        el.setSelectedRegulationVersionDetails(item);
                        el.setValidationChecksByRegulationVersion({ regulation_version_id: item.id });
                    },
                    //eslint-disable-next-line
                    onAfterSelect(id) {
                        // const table = window.webix.$$("legislationTable");
                        //eslint-disable-next-line
                        // console.log("the selccted id", table.getSelectedId());
                        // table.select(2);
                    },
                    //eslint-disable-next-line
                    // onItemClick: (id, e, node) => {
                    //     //eslint-disable-next-line
                    //     let item = this.getItem(id);
                    //     //eslint-disable-next-line
                    //     console.log("Row clicked:", item);
                    // },
                },
                onChange: {},
                onClick: {},
            };
            //
            return ui;
        },
    },
    methods: {
        ...certificateValidationMethods,
        handleModal() {
            //eslint-disable-next-line
            console.log("handle modal on legislationTable");
            this.$emit("handleModal", "createRegulationModal");
        },
    },
    watch: {
        //eslint-disable-next-line
        regulation_versions(oldVal) {
            const table = window.webix.$$("legislationTable");
            let selectedId = !!table.getSelectedId(); // typecast undefined to false
            let getFirstId = oldVal[0].id;

            if (selectedId == false) {
                setTimeout(() => {
                    table.select(getFirstId);
                }, 50);
            }
        },
    },
    mounted() {
        this.setRegulationVersions();

        // const table = window.webix.$$("legislationTable");
        // //eslint-disable-next-line
        // const rowId = "1";
        // table.select(1);
    },
};
</script>

<style lang="scss">
.suppliersTableHoverRow {
    background: #f0dcb6;
    cursor: pointer;
}
</style>
